import { render, staticRenderFns } from "./AllocationPaymentsLink.vue?vue&type=template&id=b53d3e5e&scoped=true"
import script from "./AllocationPaymentsLink.vue?vue&type=script&lang=js"
export * from "./AllocationPaymentsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53d3e5e",
  null
  
)

export default component.exports